import { UNDEFINED_SPACE_KEY } from '../types/UNDEFINED_SPACE_KEY';
import { Space } from '../types/Space';

export const isUndefinedSpace = (space: Space) => {
  const { key, visible } = space;
  return key === UNDEFINED_SPACE_KEY && !visible;
};
